<template>
  <Head title="Regulamento" />
    <RegisterLayout :showLogo="false" title="Regulamento">
      <div class="px-6">
        <p class="pb-2">Saiba mais sobre as regras da campanha:</p>
        <p class="pb-2">Etapa 1/3</p>
      </div>
    <article>
        <div class="sm:px-5 h-[535px] overflow-y-scroll">
            <!-- <HeadingGuest title="Regulamento" /> -->
            <!-- <p class="pb-2">Saiba mais sobre as regras da campanha:</p> -->
            <!-- {{$page}} -->
            <form @submit.prevent="submit">
                <ul class="grid gap-5 pt-4">
                    <li class="py-6 px-4 bg-gray-100">
                        <div v-html="regulation.text"></div>
                    </li>
                    <div class="flex" v-for="(regulationAccept, index) in regulation.regulationAccepts" :key="index">
                        <input class="hover:bg-gray-600 self-start mt-1 mr-2" type="radio" :id="'acceptTerms-' + index " :name="'acceptTerms-' + index " :value="regulationAccept.id" v-model="acceptTerms[regulationAccept.id]">
                        <label  :for="'acceptTerms-' + index ">{{ regulationAccept.text }}</label>
                    </div>
                    <li>
                    <Button
                        @click.prevent="submit()"
                        :enabled="allIsValid"
                    >
                        Avançar
                    </Button>
                    </li>
                </ul>
            </form>
        </div>
    </article>
    <ValidationErrors :errors="errors" />
  </RegisterLayout>
</template>

<script>
import RegisterLayout from "@/Layouts/Register.vue";
import Input from "@/Components/UI/Form/Input.vue";
import Label from "@/Components/Label.vue";
import Button from "@/Components/Button.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import { Inertia } from '@inertiajs/inertia'
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue";

export default {

  components: {
    Input,
    Label,
    Button,
    ValidationErrors,
    Head,
    Link,
    RegisterLayout,
    HeadingGuest,
  },

  props: {
    regulation: Object,
    acceptTerms: {
      type: Object,
      default: {}
    },
  },

  data() {
    return {
      errors: [],
    };
  },

  computed: {
      allIsValid: function() {
        const terms = JSON.parse(
            JSON.stringify(this.acceptTerms)
        );

        return Object.values(terms).filter(accepted => !accepted).length === 0
      }
  },

  methods: {
    submit() {
      this.errors = [];

        const terms = JSON.parse(
            JSON.stringify(this.acceptTerms)
        );

        if(Object.values(terms).filter(accepted => !accepted).length === 0) {
            sessionStorage.setItem('acceptRegulamento', JSON.stringify(this.acceptTerms))
            Inertia.visit('/register/transparencia', { method: 'get' })
        } else {
            this.errors.push('Aceite o regulamento para prosseguirmos')
        }
    },
  },
};
</script>
